import script from "./CopyrightFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./CopyrightFooter.vue?vue&type=script&setup=true&lang=js"

import "./CopyrightFooter.vue?vue&type=style&index=0&id=3566d1e6&lang=scss"

const __exports__ = script;

export default __exports__